import {
	Box, Container,
	Divider, makeStyles,
	Typography, LinearProgress
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import Page from 'src/components/Page';
import Profile from './Profile';
import ProfileDetails from './ProfileDetails';
import OrganisationDetails from './OrganisationProfile';
import Preferences from './Preferences';
import MobileVerification from './MobileVerification';
import { useActions, useValues } from 'kea';

import checkRole from 'src/utils/checkRole';
import profilelogic from 'src/store/profile';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingBottom: theme.spacing(3),
		paddingTop: theme.spacing(3)
	}
}));

const Account = () => {
	const classes = useStyles();

	const { profile } = useValues(profilelogic);

	return (
		<Page
			className={classes.root}
			title="Account"
		>
			<Container maxWidth={false} style={{ paddingBottom: 20 }}>
				<Box mt={3} >
					<Typography variant="h3" gutterBottom>
						Account
					</Typography>
					<Divider />
				</Box>
			</Container>
			<Container maxWidth="lg">
				<Grid
					container
					spacing={3}
				>
					<Grid
						item
						lg={6}
						md={12}
						xs={12}
					>
						<Profile />
					</Grid>
					<Grid
						item
						lg={6}
						md={12}
						xs={12}
					>
						<ProfileDetails />
					</Grid>
					<Grid
						item
						lg={6}
						md={12}
						xs={12}
					>
						<Preferences />
					</Grid>
					<Grid
						item
						lg={6}
						md={12}
						xs={12}
					>
						<MobileVerification />
					</Grid>
					<Grid
						item
						xs={12}
					>
						{checkRole(profile, ['Admin']) && <OrganisationDetails />}
					</Grid>
				</Grid>
			</Container>
		</Page>
	);
};

export default Account;
